module.exports = __webpack_public_path__ + "assets/picpay.d047fc10.svg";